export default __webpack_public_path__ + "static/media/DASH.028bb664.svg";